import React, { Component } from 'react';

import {AppProvider, Page ,Frame ,FormLayout ,Card, TextField, Select, TextStyle, Tabs, ChoiceList, Button , Thumbnail ,DropZone ,  Layout, Stack, Banner, Spinner, List, Link, Toast, Avatar} from '@shopify/polaris';
// import {
//   CalendarMinor
// } from '@shopify/polaris-icons';
// import SheetExample from '../../../../../src/components/ContactUsSheetExample/SheetExample';

import { reqGetAutomatedUserUrlName,reqInsertAutomatedCartRecoveryImage,reqInsertAutomatedCartRecovery } from '../../../../api';

import './index.css';
import OnPageSEOTabs from '../../Tabs';

import {API_DOMAIN} from '../../../../utils/constants';

class dashboard extends Component {

  state = {
    
    //弹窗
    showToast: false,  //弹窗显示
    showToastText:'',  //弹窗文字
    showToastIserror:false, //弹窗是否错误
    
    selected: 0,

    //多选框
    Multipleselected:[],

    //页面动作
    loading: true,
    loadingPage: false, 
    //输入框变量
    sendingTo:'All subscribers',
    Title:'',
    TitleError:'',
    Message:'',
    MessageError:'',
    URL:'',
    URLError:'',
    
    //下拉框数据
    httpSelectValue: 'https://',

    //图片1
    files: '',
    fileUpload:'',
    uploadedFiles:'',
    setUpdateImageWarning:'',
    setUpdateImageBackground:'',
    //图片删除按钮
    imgButton:true,
    //图片2
    filesHero: '',
    fileUploadHero:'',
    uploadedFilesHero:'',
    setUpdateImageHeroWarning:'',
    setUpdateImageHeroBackground:'',
    //图片删除按钮
    imgButtonHero:true,


    //按钮1
    httpSelectValueButton1: 'https://',
    button1Title:'',
    button1TitleError:'',
    button1Url:'',
    button1UrlError:'',

    //按钮2
    httpSelectValueButton2: 'https://',
    button2Title:'',
    button2TitleError:'',
    button2Url:'',
    button2UrlError:'',

    //用户链接
    UserUrlName: '',

    //显示警告窗口
    criticalWindow:'',

    //优惠卷框
    DiscountCode:'',

    // 预览窗口的高度设置
    previewHeight: 0,
    //保存按钮动作
    saveButton:false
  };

   //进入页面调用接口
  componentDidMount () {
    //开始调用获取网站
    this.GetCreateCampaign();

    // 挂载滚动监听
    window.addEventListener('scroll', this.handleScroll)

  }

  componentWillUnmount() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScroll);
  }

  callback=() =>{
    this.setState({})
  }
  handleScroll(event) {
    if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      
      // 滚动的高度
      // const scrollTop = (event.srcElement ? event.srcElement.documentElement.scrollTop : false) || window.pageYOffset || (event.srcElement ? event.srcElement.body.scrollTop : 0);
      // 视窗高度
      // const clientHeight = (event.srcElement && event.srcElement.documentElement.clientHeight) || document.body.clientHeight;
      
      // 页面高度
      // const scrollHeight = (event.srcElement && event.srcElement.documentElement.scrollHeight) || document.body.scrollHeight;
      // 距离页面底部的高度
      // const height = scrollHeight - scrollTop - clientHeight;
      
      // var previewObj = document.getElementById('Preview-Auto');
      
      // if(scrollTop > 133){
      //   var fixedHeight = '';
      //   if(scrollTop > 2800){
          
      //     fixedHeight = 2800 + -130 + 'px';
      //   }else{
          
      //     fixedHeight = scrollTop + -130 + 'px';
      //   }

      //   previewObj.style.marginTop = fixedHeight;

      // } else{

      //   previewObj.style.marginTop = 'unset';
      // }
    }
    
  }


  //获取数据
  GetCreateCampaign = async () => {
    const params = {type:this.props.match.params.id};
    const responseData = await reqGetAutomatedUserUrlName(params)
    if (responseData.code==='200') {
      this.setState({ 
        Title:responseData.data.Title,  //标题
        Message:responseData.data.Message, //内容
        httpSelectValue:responseData.data.httpSelectValue, //https下拉框
        URL:responseData.data.URL, //链接
        setUpdateImageBackground:responseData.data.setUpdateImageBackground, //logo图
        setUpdateImageHeroBackground:responseData.data.setUpdateImageHeroBackground, //大图
        Multipleselected:responseData.data.Multipleselected,  //所选中的按钮
        button1Title:responseData.data.button1Title,  //按钮1的标题
        httpSelectValueButton1:responseData.data.httpSelectValueButton1, //按钮1https下拉框
        button1Url:responseData.data.button1Url,  //按钮1的链接
        button2Title:responseData.data.button2Title,  //按钮2的标题
        httpSelectValueButton2:responseData.data.httpSelectValueButton2, //按钮2https下拉框
        button2Url:responseData.data.button2Url,  //按钮2的链接
        DiscountCode:responseData.data.DiscountCode, //优惠卷
        //更新状态
        loadingPage : true,
        loading : false,
        UserUrlName:responseData.data.userUrl,
      })
    }
    
    this.setUpdateImage(0,'',responseData.data.setUpdateImageBackground);
    this.setUpdateImageHero(0,'',responseData.data.setUpdateImageHeroBackground);
  }

  //提示弹窗
  toggleToast = (showToastText,showToastIserror) => {
    this.setState({
    showToastText:showToastText,
    showToastIserror:showToastIserror
    });
    this.setState(({ showToast }) => ({ showToast: !showToast }));
  };

  //输入框输入
  handleChange = (field,value) => {
    return (value) => this.setState({[field]: value,TitleError: '',MessageError: '',URLError: '',button1TitleError: '',button1UrlError: '',button2TitleError: '',button2UrlError: '',criticalWindow:''});
  };
  //URL输入框
  URLHandleChange = (Value,id) => {
    this.setState({
      TitleError: '',
      MessageError: '',
      URLError: '',
      button1TitleError: '',
      button1UrlError: '',
      button2TitleError: '',
      button2UrlError: '',
      criticalWindow:'',
    });
    var reg=/[\w-]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/;
    
    if(id === "button1Url"){
      var button1UrlError = '';
      if(!reg.test(Value)){
        if(Value){
          button1UrlError = 'Enter a valid website URL. eg: google.com'; 
        }
      }
      this.setState({
        [id] : Value,
        button1UrlError:button1UrlError,
      });
    }else if(id === "button2Url"){
      var button2UrlError = '';
      if(!reg.test(Value)){
        if(Value){
          button2UrlError = 'Enter a valid website URL. eg: google.com'; 
        }
      }
      this.setState({
        [id] : Value,
        button2UrlError:button2UrlError
      });
    }else{
      var URLError = ''; 
      if(!reg.test(Value)){
        if(Value){
          URLError = 'Enter a valid website URL. eg: google.com'; 
        }
      }
      this.setState({
        [id] : Value,
        URLError:URLError,
      });
    }
  };

  //多选框
  handleChangeMultipl = (value) => {
    this.setState({Multipleselected: value});
  };

  //下拉框替换
  handleSelectChange = (httpSelectValue) => {
    this.setState({httpSelectValue});
  };
  handleSelectChangebutton1 = (httpSelectValueButton1) => {
    this.setState({httpSelectValueButton1});
  };
  handleSelectChangebutton2 = (httpSelectValueButton2) => {
    this.setState({httpSelectValueButton2});
  };
  //切换卡片
  handleTabChange = (selectedTabIndex) => {
    this.setState({selected: selectedTabIndex});
  };
  
  //时间选择
  handleDayChange = (day) => {
    if(day){
      this.setState({ Date: day.toLocaleDateString() });
    }else{
      this.setState({ Date: ''});
    }
  }


  //上传图片
  updateImage = (acceptedFiles) => {
    this.setState({
      files: acceptedFiles[0],
    });
    this.setUpdateImage(1,acceptedFiles[0]);
  };
  
  
  //设置图片
  setUpdateImage = async (type,acceptedFiles,img) => {
    var fileUpload = '';
    var uploadedFiles = '';
    var setUpdateImageWarning = '';
    var setUpdateImageBackground = API_DOMAIN+"/logo.jpg";
    if(img){
      fileUpload = !img && <DropZone.FileUpload />;
      uploadedFiles = img && (
        <div className="addImage">
         <Thumbnail
            size="small"
            alt=''
            source={img}
          />
        </div>
      );
      this.setState({
        imgButton: false,
        fileUpload: fileUpload,
        uploadedFiles: uploadedFiles
      });
    }else if(acceptedFiles){
      const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
      const filesImg = acceptedFiles
      if(validImageTypes.indexOf(filesImg.type) >= 0){
        fileUpload = !filesImg && <DropZone.FileUpload />;
        
        //开启FileReader
        var reader  = new FileReader();
        reader.readAsDataURL(filesImg); //读取文件保存在result中
        reader.onload = (e) =>  {
          var getRes = e.target.result;//读取的结果在result中
          const params = {img:getRes,type:filesImg.type};
          reqInsertAutomatedCartRecoveryImage(params).then(response => {
            if (response.code==='200') {
              uploadedFiles = filesImg && (
                <div className="addImage">
                 <Thumbnail
                    size="small"
                    alt={filesImg.name}
                    source={response.data}
                  />
                </div>
              );
              setUpdateImageBackground = response.data;
            }else{
              fileUpload = <DropZone.FileUpload />;
              uploadedFiles = '';
            }
            
            this.setState({
              imgButton: false,
              fileUpload: fileUpload,
              uploadedFiles: uploadedFiles,
              setUpdateImageBackground:setUpdateImageBackground
            });
          })
        }
      }else{
        fileUpload = <DropZone.FileUpload />;
        uploadedFiles = ''
        setUpdateImageWarning = <Banner title="The following images couldn’t be uploaded:" status="warning">
          <List>
            <List.Item>
              File type must be .jpg .jpeg .png.
            </List.Item>
          </List>
          <p></p>
        </Banner>
        this.setState({
          fileUpload: fileUpload,
          uploadedFiles: uploadedFiles,
          setUpdateImageWarning: setUpdateImageWarning,
          setUpdateImageBackground:setUpdateImageBackground
        });
      }
    }else{
      fileUpload = <DropZone.FileUpload />;
      uploadedFiles = ''
      //如果提交的文件不是图片 就提醒报错
      if(type === 1){
        setUpdateImageWarning = <Banner title="The following images couldn’t be uploaded:" status="warning">
          <List>
            <List.Item>
              File type must be .jpg .jpeg .png.
            </List.Item>
          </List>
        </Banner>
      }
      this.setState({
        fileUpload: fileUpload,
        uploadedFiles: uploadedFiles,
        setUpdateImageWarning: setUpdateImageWarning,
        setUpdateImageBackground:setUpdateImageBackground
      });
    }
  }

  //删除图片
  deleteImage = () => {
    this.setState({
      files: '',
      imgButton: true,
    });
    this.setUpdateImage();
  }

  //上传图片
  updateImageHero = (acceptedFiles) => {
    this.setState({
      filesHero: acceptedFiles[0],
    });
    this.setUpdateImageHero(1,acceptedFiles[0]);
  };

  //设置图片
  setUpdateImageHero = (type,acceptedFiles,img) => {
    var fileUploadHero = '';
    var uploadedFilesHero = '';
    var setUpdateImageHeroWarning = "";
    var setUpdateImageHeroBackground = API_DOMAIN+"/Untitled.jpg";
    if(img){
      fileUploadHero = !img && <DropZone.FileUpload />;
      uploadedFilesHero = img && (
        <div className="addHerpImage">
         <Thumbnail
            size="small"
            alt=''
            source={img}
          />
        </div>
      );
      this.setState({
        imgButtonHero: false,
        fileUploadHero: fileUploadHero,
        uploadedFilesHero: uploadedFilesHero
      });
    }else if(acceptedFiles){
      const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
      const filesImg = acceptedFiles
      if(validImageTypes.indexOf(filesImg.type) >= 0){
        fileUploadHero = !filesImg && <DropZone.FileUpload />;


        //开启FileReader
        var reader  = new FileReader();
        reader.readAsDataURL(filesImg); //读取文件保存在result中
        reader.onload = (e) =>  {
          var getRes = e.target.result;//读取的结果在result中
          const params = {img:getRes,type:filesImg.type};
          reqInsertAutomatedCartRecoveryImage(params).then(response => {
            if (response.code==='200') {
              uploadedFilesHero = filesImg && (
                <div className="addHerpImage">
                 <Thumbnail
                    size="small"
                    alt={filesImg.name}
                    source={response.data}
                  />
                </div>
              );
              setUpdateImageHeroBackground = response.data;
            }else{
              fileUploadHero = <DropZone.FileUpload />;
              uploadedFilesHero = '';
            }
            this.setState({
              imgButtonHero: false,
              fileUploadHero: fileUploadHero,
              uploadedFilesHero: uploadedFilesHero,
              setUpdateImageHeroBackground:setUpdateImageHeroBackground,
            });
          })
        }

      }else{
        fileUploadHero = <DropZone.FileUpload />;
        uploadedFilesHero = ''
        setUpdateImageHeroWarning = <Banner title="The following images couldn’t be uploaded:" status="warning">
          <List>
            <List.Item>
              File type must be .jpg .jpeg .png.
            </List.Item>
          </List>
        </Banner>
        this.setState({
          fileUploadHero: fileUploadHero,
          uploadedFilesHero: uploadedFilesHero,
          setUpdateImageHeroWarning: setUpdateImageHeroWarning,
          setUpdateImageHeroBackground:setUpdateImageHeroBackground
        });
      }
    }else{
      fileUploadHero = <DropZone.FileUpload />;
      uploadedFilesHero = ''
      if(type === 1){
        setUpdateImageHeroWarning = <Banner title="The following images couldn’t be uploaded:" status="warning">
          <List>
            <List.Item>
              File type must be .jpg .jpeg .png.
            </List.Item>
          </List>
        </Banner>
      }
        
      this.setState({
        fileUploadHero: fileUploadHero,
        uploadedFilesHero: uploadedFilesHero,
        setUpdateImageHeroWarning: setUpdateImageHeroWarning,
        setUpdateImageHeroBackground:setUpdateImageHeroBackground
      });
    }
  }

  //删除图片
  deleteImageHero = () => {
    this.setState({
      filesHero: '',
      imgButtonHero: true,
    });
    this.setUpdateImageHero();
  }

  //保存
  insertCreateCampaign = async () => {
    //判断是否允许提交
    var isAllow = 1;
    //错误字符提示 以及 个数
    var criticalCharacter1 = '';
    var criticalCharacter2 = '';
    var criticalCharacter3 = '';
    var criticalCharacter4 = '';
    var criticalCharacter5 = '';
    var criticalCharacter6 = '';
    var criticalCharacter7 = '';
    var criticalCharacter8 = '';
    var criticalCharacter9 = '';
    var criticalCharacter10 = '';
    var criticalCount = 0;
    
    //判断必填项
    if(this.state.Title === ''){
      criticalCharacter1 = <List.Item>Content title is required</List.Item>;
      criticalCount = criticalCount + 1;
      isAllow = 0;
      this.setState({TitleError: 'Required'});
    }
    if(this.state.Message === ''){
      criticalCharacter2 = <List.Item>Content body is required</List.Item>
      criticalCount = criticalCount + 1;
      isAllow = 0;
      this.setState({MessageError: 'Required'});
    }
    if(this.state.URL === ''){
      criticalCharacter3 = <List.Item>Content url is required</List.Item>
      criticalCount = criticalCount + 1;
      isAllow = 0;
      this.setState({URLError: 'Required'});
    }else{
      if(this.state.URLError !== ''){
        criticalCharacter4 = <List.Item>Content url: Enter a valid website URL. eg: google.com</List.Item>
        criticalCount = criticalCount + 1;
        isAllow = 0;
      }
    }

    //按钮1
    if(this.state.Multipleselected.indexOf('button1') >= 0){
      if(this.state.button1Title === ''){
        criticalCharacter5 = <List.Item>Content action buttons 1 title is required</List.Item>
        criticalCount = criticalCount + 1;
        isAllow = 0;
        this.setState({button1TitleError: 'Required'});
      }
      if(this.state.button1Url === ''){
        criticalCharacter6 = <List.Item>Content action buttons 1 url is required</List.Item>
        criticalCount = criticalCount + 1;
        isAllow = 0;
        this.setState({button1UrlError: 'Required'});
      }else{
        if(this.state.button1UrlError !== ''){
          criticalCharacter7 = <List.Item>Content action buttons 1 url: Enter a valid website URL. eg: google.com</List.Item>
          criticalCount = criticalCount + 1;
          isAllow = 0;
        }
      }
    }

    //按钮2
    if(this.state.Multipleselected.indexOf('button2') >= 0){
      if(this.state.button2Title === ''){
        criticalCharacter8 = <List.Item>Content action buttons 2 title is required</List.Item>
        criticalCount = criticalCount + 1;
        isAllow = 0;
        this.setState({button2TitleError: 'Required'});
      }
      if(this.state.button2Url === ''){
        criticalCharacter9 = <List.Item>Content action buttons 2 url is required</List.Item>
        criticalCount = criticalCount + 1;
        isAllow = 0;
        this.setState({button2UrlError: 'Required'});
      }else{
        if(this.state.button2UrlError !== ''){
          criticalCharacter10 = <List.Item>Content action buttons 2 url: Enter a valid website URL. eg: google.com</List.Item>
          criticalCount = criticalCount + 1;
          isAllow = 0;
        }
      }
    }
    //判断是否允许提交
    if(isAllow === 1){
      this.setState({
        saveButton:true
      });
      const params = {
        Title:this.state.Title,  //标题
        Message:this.state.Message, //内容
        URL:this.state.URL, //链接
        httpSelectValue:this.state.httpSelectValue, //https下拉框
        Multipleselected:this.state.Multipleselected,  //所选中的按钮
        button1Title:this.state.button1Title,  //按钮1的标题
        button1Url:this.state.button1Url,  //按钮1的链接
        httpSelectValueButton1:this.state.httpSelectValueButton1, //按钮1https下拉框
        button2Title:this.state.button2Title,  //按钮2的标题
        button2Url:this.state.button2Url,  //按钮2的链接
        httpSelectValueButton2:this.state.httpSelectValueButton2, //按钮2https下拉框
        setUpdateImageBackground:this.state.setUpdateImageBackground, //logo图
        setUpdateImageHeroBackground:this.state.setUpdateImageHeroBackground, //大图
        DiscountCode:this.state.DiscountCode,  //优惠码
        type:this.props.match.params.id  //修改类型
      };
      
      const responseData = await reqInsertAutomatedCartRecovery(params)
      if (responseData.code==='200') {
        this.setState({ 
          saveButton:false
        })
        this.toggleToast(responseData.msg,false);
      }else{
        this.toggleToast(responseData.msg,true);
      }
    }else{
      var criticalWindow = <div style={{ marginBottom:"2rem"}}>
        <Banner title={`To add this message, `+criticalCount+` fields need changes`} status="critical">
          <List>
            {criticalCharacter1}
            {criticalCharacter2}
            {criticalCharacter3}
            {criticalCharacter4}
            {criticalCharacter5}
            {criticalCharacter6}
            {criticalCharacter7}
            {criticalCharacter8}
            {criticalCharacter9}
            {criticalCharacter10}
          </List>
        </Banner>
      </div>
      this.setState({
        criticalWindow: criticalWindow
      });
    }
   
  }

  //获取周几
  GetDate(){
    var todays = new Date(),
    date = todays.getFullYear() + '-' + (todays.getMonth() + 1) + '-' + todays.getDate();
    const day = new Date(Date.parse(date.replace(/-/g, '/')));
    const today = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return today[day.getDay()]
  }

  //获取时间
  formatDate() {
    var todays = new Date(),
    date = todays.getFullYear() + '-' + (todays.getMonth() + 1) + '-' + todays.getDate() + " " + todays.getHours() + ":" + todays.getMinutes(); 

    var d = new Date(date);
    var hh = d.getHours();
    var m = d.getMinutes();
    var dd = "AM";
    var h = hh;
    if (h > 12) {
      h = hh - 12;
      dd = "PM";
    }
    
    if (h === 0) {
      h = 12;
    }
    m = m < 10 ? "0" + m : m;
    h = h<10?"0"+h:h;
  
    
    return h+":"+m+" "+dd;

  }

  //获取日期
  GetTime(){
    var todays = new Date(),
    date = todays.getFullYear() + '-' + (todays.getMonth() + 1) + '-' + todays.getDate() + " " + todays.getHours() + ":" + todays.getMinutes(); 

    var dd = new Date(date);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    var d = dd.getDate()
    d = d < 10 ? "0" + d : d;
    date = y + '-' + (m) + '-' + d;
    return date
  }
  

  render() {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={this.toggleToast} error={this.state.showToastIserror} /> : null;
    const loadingMarkup = this.state.loading ? <div className="loadingCenter"><Spinner size="large" color="teal" /></div> : '';
    const {

      state: { fileUpload,uploadedFiles,
        // fileUploadHero,uploadedFilesHero,
        sendingTo,Title,Message,URL,Multipleselected,button1Title,button1Url,button2Title,button2Url,httpSelectValue,httpSelectValueButton1,httpSelectValueButton2,selected,setUpdateImageWarning,
        // setUpdateImageHeroWarning,
        setUpdateImageBackground,setUpdateImageHeroBackground,TitleError,MessageError,URLError,button1TitleError,button1UrlError,button2TitleError,button2UrlError,DiscountCode,criticalWindow,saveButton},
      handleChange,
      updateImage,
      deleteImage,
      // updateImageHero,
      // deleteImageHero,
    } = this;
    var button1Content = '';
    //判断按钮1
    if(Multipleselected.indexOf('button1') >= 0){
      button1Content = <div>
       <FormLayout>
        <TextField
          label="Title"
          onChange={handleChange('button1Title')}
          value={button1Title}
          maxLength={50}
          showCharacterCount
          helpText="Perfect length is 15 characters"
          error={button1TitleError}
        /> 
        <TextField
          label="Url"
          id="button1Url"
          onChange={this.URLHandleChange}
          value={button1Url}
          error={button1UrlError}
          connectedLeft={
            <Select 
              value={httpSelectValueButton1}
              label="Weight unit"
              onChange={this.handleSelectChangebutton1}
              labelHidden
              options={['https://', 'http://']}
            />
          }
        />  
        </FormLayout>
    </div>;
    }
    
    var button2Content = '';
    //判断按钮2
    if(Multipleselected.indexOf('button2') >= 0){
       button2Content = <div>
        <FormLayout>
          <TextField
            label="Title"
            onChange={handleChange('button2Title')}
            value={button2Title}
            maxLength={50}
            showCharacterCount
            helpText="Perfect length is 15 characters"
            error={button2TitleError}
          /> 
          <TextField
            label="Url"
            id="button2Url"
            onChange={this.URLHandleChange}
            error={button2UrlError}
            value={button2Url}
            connectedLeft={
              <Select 
                value={httpSelectValueButton2}
                label="Weight unit"
                onChange={this.handleSelectChangebutton2}
                labelHidden
                options={['https://', 'http://']}
              />
            }
          />  
        </FormLayout>
    </div>;
    }

    const tabs = [
      {
        id: '0',
        content: 'Windows',
        panelID: 'Windows',
      },
      {
        id: '1',
        content: 'Android',
        panelID: 'Android',
      },
      {
        id: '2',
        content: 'Mac',
        panelID: 'Mac',
      },
    ];

    //Preview 切换卡片
    var tabsContent = '';
    if(this.state.loadingPage === true){

      if(selected === 0){
      //设置按钮显示
        var buttonShow = '';

        if(Multipleselected.indexOf('button1') >= 0 || Multipleselected.indexOf('button2') >= 0){
          if(Multipleselected.indexOf('button1') >= 0){
            var button1Show = '';
            if(button1Title){
              button1Show = <span>{button1Title}</span>
            }
          }
          if(Multipleselected.indexOf('button2') >= 0){
            var button2Show = '';
            if(button2Title){
              button2Show = <span>{button2Title}</span>
            }
          }
          buttonShow = <section className="Android_Preview_Actions">{button1Show}{button2Show}</section>
        } 

        tabsContent = <Card.Section>
          <div className=""  style={{ background:"url('/winback.jpg')  no-repeat",height:"600px",width: "100%",overflow: "hidden",backgroundSize: "cover",backgroundPosition: "right bottom",position: "relative" }}>
            
            <div className="ht-preview--windows__time"><div>{this.formatDate()}</div><div>{this.GetTime()}</div></div>
            <section className="" style={{ width:"85%",maxWidth:"400px",position:"absolute",right:"10px",bottom:"60px",backgroundColor:"white" }}>
              <Card>
                <Card.Section>
                  <Stack  vertical={true}>
                    <Stack vertical={true}>
                      <div>{this.state.UserUrlName}</div>
                      <Stack distribution="equalSpacing">
                        <Stack vertical={true}>
                          <section className="Message_Title"><span className="">{this.state.Title}</span></section>
                          <section className="Message_Content">
                            <div className="Polaris-Stack__Itemclass">
                              <Stack vertical={true}>
                                <span>{this.state.Message}</span>
                              </Stack>
                            </div>
                          </section>
                        </Stack>
                        
                        <Thumbnail
                            source={setUpdateImageBackground}
                            size="small"
                            alt="Black choker necklace"
                          />
                      </Stack>
                    </Stack>
                  </Stack>
                  
                </Card.Section>
                <div className="Android_Preview_Image" style={{ backgroundImage:"url("+setUpdateImageHeroBackground+")" }}></div>
                {buttonShow}
              </Card>
            </section>
          </div>
        </Card.Section>
      }else if(selected === 1){
        //   //设置按钮显示
          var b2buttonShow = '';
          if(Multipleselected.indexOf('button1') >= 0 || Multipleselected.indexOf('button2') >= 0){
            if(Multipleselected.indexOf('button1') >= 0){
              var b2button1Show = '';
              if(button1Title){
                b2button1Show = <Link>{button1Title}</Link>
              }
            }
            if(Multipleselected.indexOf('button2') >= 0){
              var b2button2Show = '';
              if(button2Title){
                b2button2Show = <Link>{button2Title}</Link>
              }
            }
            b2buttonShow = <div style={{ marginLeft:"70px" }}><Stack>
              {b2button1Show}
              
              {b2button2Show}
            </Stack></div>
          }
          tabsContent = <Card.Section>
          <div className="design-mobile4" style={{background:"url('/mobile5.png')  no-repeat top",backgroundSize:"100% auto"}}>
            <section className="Preview">
              <Card sectioned>
                <Stack  vertical={true}>
                  <Stack>
                    <Thumbnail
                        source={setUpdateImageBackground}
                        size="small"
                        alt="Black choker necklace"
                      />
                      
                        <Stack vertical={true}>
                          <section className="Message_Title"><span className="">{this.state.Title}</span></section>
                          <section className="Message_Content">
                            <div className="Polaris-Stack__Itemclass">
                              <Stack vertical={true}>
                                <span>{this.state.Message}</span>
                              </Stack>
                            </div>
                          </section>
                        </Stack>
                    </Stack>
                    <div className="Preview_Image" style={{ backgroundImage:"url("+setUpdateImageHeroBackground+")" ,marginLeft:"70px"}}></div>
                    
                    {b2buttonShow}
                </Stack>
              </Card>
            </section>
          </div>
        </Card.Section>;
      }else if(selected === 2){
          tabsContent = 
          <Card.Section>
          <div className=""  style={{ background:"url('/macback.jpg')  no-repeat",height:"415px",width: "100%",overflow: "hidden",backgroundSize: "cover",backgroundPosition: "right top",position: "relative" }}>
            <div className="ht-preview--mac__time">{this.GetDate()} {this.formatDate()}</div>
            <section className="MacPreview" style={{ width:"94%",margin:"8% auto" }}>
              <section className="MacPreview_Card">
                <Card>
                  <Stack alignment="center">
                    <section style={{marginLeft:"2rem"}}>
                      <Avatar customer name="Farrah" source="/mac_chrome.iso.f3b6c54c.svg"/>
                    </section>
                    <Stack.Item fill>
                      <Stack vertical={true} spacing="extraTight">
                        <div className="Mac_Message_Title">{this.state.Title}</div>
                        <span>{this.state.UserUrlName}</span>
                        <div className="Mac_Message_Content">{this.state.Message}</div>
                      </Stack>
                    </Stack.Item>
                    <Card>
                      <Card.Section>
                        Close
                      </Card.Section>
                      <Card.Section>
                        Settings
                      </Card.Section>
                    </Card>
                  </Stack>
                </Card>
              </section>
            </section>
          </div>
        </Card.Section>;
      }
   }


    return (
      <div className="frame_page_padding">
      <AppProvider>
        <Frame topBar={<div>
          <OnPageSEOTabs
            callback={this.callback}
          />
            <div className="headerTab headerTabTop">
              <Card>
                <div style={{ textAlign:"right",padding:"1rem 2rem"}}>
                  <Button primary onClick={ () => this.insertCreateCampaign() } loading={saveButton}>Save</Button>
                </div>
              </Card>
            </div>
          </div> } >
          <Page 
            breadcrumbs={[{content: 'Automated Cart Recovery', url: '/admin/automated-cart-recovery/index'}]}
            title="Update web push"
          >
            {criticalWindow}
            <Layout>
              <Layout.Section secondary>
                <Card title="CONTENT">
                  <Card.Section>
                    <FormLayout>
                      <TextField
                          disabled
                          label="Sending to"
                          onChange={handleChange('sendingTo')}
                          value={sendingTo}
                        />  
                        <TextField
                          label="Title"
                          onChange={handleChange('Title')}
                          value={Title}
                          maxLength={100}
                          showCharacterCount
                          helpText="Perfect length is 21 characters"
                          error={TitleError}
                        />  
                        <TextField
                          label="Message"
                          onChange={handleChange('Message')}
                          value={Message}
                          maxLength={200}
                          showCharacterCount
                          helpText="Perfect length is 23 characters"
                          error={MessageError}
                        /> 
                        <TextField
                          label="URL"
                          id="URL"
                          onChange={this.URLHandleChange}
                          value={URL}
                          helpText="Your customers will see this web page when they tap on the content or hero image."
                          error={URLError}
                          connectedLeft={
                            <Select 
                              value={httpSelectValue}
                              label="Weight unit"
                              onChange={this.handleSelectChange}
                              labelHidden
                              options={['https://', 'http://']}
                            />
                          }
                        />  
                       
                    </FormLayout>
                  </Card.Section>   
                  <Card.Section title="BRAND LOGO">
                    <Stack vertical={true}  >
                      <TextStyle variation="subdued">64px x 64px; Less than 1MB; Accepts .jpg, .jpeg, .png.</TextStyle>
                      {setUpdateImageWarning}
                      <Stack spacing="loose" distribution="center">
                        <div style={{width: 134, height: 134,margin:'0 auto'}}>
                        <DropZone
                         accept="image/*"
                          type="image"
                          onDrop={(files, acceptedFiles, rejectedFiles) => {
                            updateImage(acceptedFiles)
                          }}
                        >
                          {uploadedFiles}
                          {fileUpload}
                        </DropZone>
                        </div>
                        <Button disabled={this.state.imgButton} onClick={() => deleteImage() }>Remove</Button>
                      </Stack>
                    </Stack>
                  </Card.Section>
                </Card>
                {/* <Card title="HERO IMAGE" sectioned>
                  <Stack vertical={true} >
                    <TextStyle variation="subdued">450px x 200px; Less than 2MB; Accepts .jpg, .jpeg, .png.</TextStyle>
                    {setUpdateImageHeroWarning}
                    <DropZone
                      accept="image/*"
                      type="image"
                      onDrop={(files, acceptedFiles, rejectedFiles) => {
                        updateImageHero(acceptedFiles)
                      }}
                    >
                      {uploadedFilesHero}
                      {fileUploadHero}
                    </DropZone>
                    <div style={{textAlign:"center"}}>
                      <Button disabled={this.state.imgButtonHero} onClick={() => deleteImageHero() }>Remove</Button>
                    </div>
                  </Stack>
                </Card> */}
                
                <Card>
                  <Card.Section title="ACTION BUTTONS">
                    <FormLayout> 
                      <ChoiceList
                        allowMultiple
                        choices={[
                          {
                            label: '1st action button',
                            value: 'button1',
                            helpText : button1Content
                          }
                        ]}
                        selected={Multipleselected}
                        onChange={this.handleChangeMultipl}
                      />
                      <ChoiceList
                        allowMultiple
                        choices={[
                          {
                            label: '2nd action button',
                            value: 'button2',
                            helpText : button2Content
                          },
                        ]}
                        selected={Multipleselected}
                        onChange={this.handleChangeMultipl}
                      />
                    </FormLayout> 
                  </Card.Section>   
                </Card>
                
                <Card>
                  <Card.Section title="DISCOUNT">
                    <FormLayout>
                      <TextField
                          label="Discount Code"
                          onChange={handleChange('DiscountCode')}
                          value={DiscountCode}
                          helpText="Please also include your discount code in the title or message."
                        /> 
                        <Link url={`https://`+this.state.UserUrlName+"/admin/discounts"} external={true}>Create discount code</Link>
                    </FormLayout>
                  </Card.Section>
                </Card>

              </Layout.Section>
              <Layout.Section secondary>
                <div id="Preview-Auto">
                  <Card title="Preview">
                    <Tabs
                      tabs={tabs}
                      selected={selected}
                      onSelect={this.handleTabChange}
                      fitted
                    >
                      {loadingMarkup}
                      {tabsContent}
                        
                    </Tabs>
                  </Card>
                </div>
              </Layout.Section>
            </Layout>
            {toastMarkup}
            <div className="space"></div>
            {/* <SheetExample /> */}
          </Page>
        </Frame>
      </AppProvider>
      </div>
    );
  }
}

export default dashboard;
